import React from 'react';
import { Modal } from '@mantine/core';
import type { OrderView } from 'shared-models/browser';
import { aggregatorChannelLabel } from '../aggregator-order.utils';
import { WoltOrderPanel } from './WoltOrderPanel';

type WoltOrderModalProps = {
  order: OrderView | null;
  tenantId: string;
  employeeSession: string | null;
  isManager: boolean;
  onClose: () => void;
  onAccepted?: (order: OrderView) => void;
};

// List-row entry point (incl. the paid list, where closed Wolt orders await מוכן / נמסר).
export const WoltOrderModal: React.FC<WoltOrderModalProps> = ({ order, tenantId, employeeSession, isManager, onClose, onAccepted }) => (
  <Modal
    opened={order !== null}
    onClose={onClose}
    title={order ? `הזמנת ${aggregatorChannelLabel(order.orderCode)} ${order.orderCode}` : ''}
    centered
    radius="md"
    size="md"
    zIndex={301}
    closeButtonProps={{ 'data-testid': 'wolt-order-modal-close' } as Record<string, string>}
  >
    {order && (
      <WoltOrderPanel
        tenantId={tenantId}
        employeeSession={employeeSession}
        isManager={isManager}
        order={order}
        onAccepted={onAccepted}
      />
    )}
  </Modal>
);
